import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import SelectField from '../components/form/SelectField';
import { Context } from '../context/DataContext';

const CheckOrderInfoAgainPage = () => {
  const navigate = useNavigate();
  const {
    state,
    updateOrderInsurance,
    setCustomerInfo,
    checkAPTGUserStatus,
    getInsuranceDocInfo,
    setEmployeeInfo,
  } = React.useContext(Context);
  const {
    customerInfo,
    paymentList,
    loginInfo: { empNo },
  } = state;
  const [paymentMethod, setPaymentMethod] = React.useState(customerInfo.payType || '');
  const [periodType, setPeriodType] = React.useState(customerInfo.periodType || '');
  const [warrantyMonth, setWarrantyMonth] = React.useState(
    customerInfo.warrantyMonth ? String(customerInfo.warrantyMonth) : ''
  );
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const paymentInfo = paymentMethod
    ? paymentList.find(
      ({ PaymentType, PeriodType, WarrantyMonth }) =>
        PaymentType === paymentMethod &&
        PeriodType === periodType &&
        String(WarrantyMonth) === warrantyMonth
    )
    : {};

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        要保資料確認
      </Typography>
      <Box sx={{ px: 2, textAlign: 'left' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
          機型：{customerInfo.market_n}
        </Typography>
        <Typography variant="h6" sx={{ my: 2 }}>
          IMEI：{customerInfo.imei}
        </Typography>
        <Typography variant="h6" sx={{ my: 2 }}>
          服務名稱：{customerInfo.serviceName}
        </Typography>
        <SelectField
          fullWidth
          id="payment-method"
          label="付款方式"
          placeholder="請選擇..."
          value={paymentMethod ? `${paymentMethod}+${periodType}+${warrantyMonth}` : ''}
          onChange={(e) => {
            const [paymentMethod, periodType, warrantyMonth] = e.target.value.split('+');
            setPaymentMethod(paymentMethod);
            setPeriodType(periodType);
            setWarrantyMonth(warrantyMonth);
          }}
          options={paymentList.map(
            ({ PaymentType, PaymentTypeName, PeriodType, WarrantyMonth }) => ({
              id: `${PaymentType}+${PeriodType}+${WarrantyMonth}`,
              value: `${PaymentType}+${PeriodType}+${WarrantyMonth}`,
              text: PaymentTypeName,
            })
          )}
        />
        {paymentMethod ? (
          <>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`保險費：${paymentInfo.InsurancePrice}元`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`置換費用：${paymentInfo.SwapPrice}元`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`生效日期：${paymentInfo.InsuranceStartDate}`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`到期日期：${paymentInfo.InsuranceEndDate}`}
            </Typography>
            {errorMsg ? (
              <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
                {errorMsg}
              </Typography>
            ) : null}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <Button
                color="secondary"
                variant="contained"
                sx={{ width: 128 }}
                onClick={() => {
                  navigate('/dashboard');
                }}
              >
                不同意
              </Button>
              <LoadingButton
                variant="contained"
                sx={{ width: 128 }}
                loading={loading}
                onClick={() => {
                  const updateOrNot = () => {
                    if (customerInfo.payType === paymentMethod && customerInfo.warrantyMonth === warrantyMonth) {
                      navigate('/check-pdf-again');
                    } else {
                      const {
                        InsurancePrice,
                        InsuranceName,
                        PaymentExecTimes,
                        SwapPrice,
                        PeriodType,
                        PaymentTypeName,
                        InsuranceStartDate,
                        InsuranceEndDate,
                      } = paymentInfo;
                      // Get Insurance Doc Info again
                      getInsuranceDocInfo(
                        {
                          orderId: customerInfo.orderId,
                          payType: paymentMethod,
                          userId: empNo,
                          insurancePrice: InsurancePrice,
                          serviceName: InsuranceName,
                          periodType: PeriodType,
                        },
                        (data) => {
                          const { ResponseCode, ResponseMSG } = data;

                          if (ResponseCode === '1') {
                            const {
                              InsuranceAgentAutography,
                              InsuranceAgentName,
                              InsuranceNo,
                              SellingPrice,
                              RepCenterName,
                              LicenseNo,
                              TimesOfRMA,
                            } = data;
                            updateOrderInsurance(
                              {
                                fromDate: InsuranceStartDate,
                                insurancePrice: InsurancePrice,
                                operator: empNo,
                                orderId: customerInfo.orderId,
                                payment: paymentMethod,
                                paymentText: PaymentTypeName,
                                periodType: PeriodType,
                                serviceName: InsuranceName,
                                swapPrice: SwapPrice,
                                toDate: InsuranceEndDate,
                                validPeriod: PaymentExecTimes,
                                insuranceNo: InsuranceNo,
                              },
                              ({ responseCode, responseMsg }) => {
                                if (responseCode === '000') {
                                  setEmployeeInfo(
                                    {
                                      previousSign: InsuranceAgentAutography,
                                      empName: InsuranceAgentName,
                                      empCode: LicenseNo,
                                    },
                                    () => {
                                      setCustomerInfo(
                                        {
                                          payType: paymentMethod,
                                          insurancePrice: InsurancePrice,
                                          serviceName: InsuranceName,
                                          fromDate: InsuranceStartDate,
                                          toDate: InsuranceEndDate,
                                          validPeriod: PaymentExecTimes,
                                          swapPrice: SwapPrice,
                                          periodType: PeriodType,
                                          paymentText: PaymentTypeName,
                                          repairTarget: RepCenterName,
                                          phonePrice: SellingPrice,
                                          insuranceNo: InsuranceNo,
                                          repairCount: TimesOfRMA,
                                        },
                                        () => {
                                          setLoading(false);
                                          navigate('/check-pdf-again');
                                        }
                                      );
                                    }
                                  );
                                }
                              }
                            );
                          } else {
                            setLoading(false);
                            setErrorMsg(ResponseMSG);
                          }
                        }
                      );
                    }
                  };

                  setLoading(true);
                  if (paymentMethod === 'tel_bill') {
                    checkAPTGUserStatus(
                      {
                        userImei: customerInfo.imei,
                        userMdn: customerInfo.phone,
                        orderId: customerInfo.orderId,
                      },
                      ({ responseCode, responseMsg }) => {
                        if (responseCode === '000') {
                          updateOrNot();
                        } else {
                          setLoading(false);
                          setErrorMsg(responseMsg);
                        }
                      }
                    );
                  } else {
                    updateOrNot();
                  }
                }}
              >
                確認要保書
              </LoadingButton>
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default CheckOrderInfoAgainPage;
